import React, { useState, useRef, useEffect } from "react";
import Grid from '@mui/material/Grid';
import LinearProgress from "@mui/material/LinearProgress";
import {
    Button,
    Typography,
    Box,
} from "@mui/material";
import Modal from "@mui/material/Modal";
// import '../../../css/Referrals.css';
import SnackbarAlert from '../../common/SnackbarAlert';
import CircularProgress from '@mui/material/CircularProgress';
import IconImage from "../../../media/site_media/illustrations/Icon-Image@2x.png";
import { IoClose } from "react-icons/io5";
import extractFileExt from '../../Content/content_upload_type/common/extractFileExt';
import axios from "axios";
import { PiInfoBold } from "react-icons/pi";
import { styled } from "@mui/material/styles";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import getImageUrl from "../../../utils/getImageUrl";
const paths = require('../../../paths.json');

const modalStyle = {
    display: 'flex',
    height: 'auto',
    // bgcolor: 'rgba(0,0,0,1)',
    minHeight: '100vh',
    minWidth: '100vw',
    overflowY: 'hidden',
    outline: 'none',
    zIndex: '9999',
};

const DarkTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: '#222222 !important',
        color: '#ffffff',
        boxShadow: theme.shadows[1],
        fontSize: 11,
        margin: '0px'
    },
}));

function PlatformBranding(props) {
    const [screenWidth, setScreenWidth] = useState(window.innerWidth);
    const [squareLogoFileNewSize, setSquareLogoFileNewSize] = useState('');
    const [squareLogoFileNewErrorMsg, setSquareLogoFileNewErrorMsg] = useState('');
    const [rectangleLogoFileNewSize, setRectangleLogoFileNewSize] = useState('');
    const [rectangleLogoFileNewSizeErrorMsg, setRectangleLogoFileNewSizeErrorMsg] = useState('');
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbar, setSnackbar] = useState(false);
    const [snackbarMsg, setSnackbarMsg] = useState('Logo uploaded successfully');
    const [image1, setImage1] = useState(null);
    const [image2, setImage2] = useState(null);

    const fileInputRefSquare = useRef(null);
    const fileInputRefRectangle = useRef(null);

    const [errorMsgLogo, setErrorMsgLogo] = useState('');
    const [snackbarLogo, setSnackbarLogo] = useState(false);
    const [uploadMessageLogo, setUploadMessageLogo] = useState('');
    const [uploadPercentLogo, setUploadPercentLogo] = useState(0);
    const [uploadStepLogo, setUploadStepLogo] = useState('');
    const [fileSizeLogo, setFileSizeLogo] = useState(0);
    const [uploadSpeedsLogo, setUploadSpeedsLogo] = useState([]);
    const [uploadStartTimeLogo, setUploadStartTimeLogo] = useState(null);
    const [timeRemainingLogo, setTimeRemainingLogo] = useState(null);
    const [timeRemainingIntervalLogo, setTimeRemainingIntervalLogo] = useState(null);
    const [dateTimeLogo, setDateTimeLogo] = useState('');
    const [snackbarAutoHideLogo, setSnackbarAutoHideLogo] = useState(4000);
    const [controllerLogo, setControllerLogo] = useState('');
    const [timeoutTimerLogo, setTimeoutTimerLogo] = useState(0);
    const [prevPercentLogo, setPrevPercentLogo] = useState(0);
    const [uploadLoadingLogo, setUploadLoadingLogo] = useState(false);
    const initInterval = useRef(false)
    const initTimeoutInterval = useRef(false)
    const timeOutInterval = useRef()
    const [squarePlaceholderLogo, setSlaceholderLogo] = useState(true);
    const [rectanglePlaceholderLogo, setRectanglePlaceholderLogo] = useState(true);


    async function notifyUploadCompleteLogo(type) {
        const startTime = performance.now();
        const response = await axios({
            method: 'get',
            url: paths.BACKEND_URL + 'api/upload_logo/complete/' + type,
            headers: {
                'Content-type': 'application/json',
            },
            withCredentials: true
        });
        return response;
    }

    async function uploadLogoFile(type, total_steps, start_step) {
        //TODO: Sanatise the data and check it has everything needed for a succesful post
        const form_data = new FormData();
        form_data.append('type', type.toLowerCase());
        let file = ''
        if (type === 'square') {
            file = props.logoSquareFileNew
        } else {
            file = props.logoRectangleFileNew
        }
        form_data.append('ext', extractFileExt(file.name))
        timeRemainingIntervalLogo && clearInterval(timeRemainingIntervalLogo)
        setTimeRemainingIntervalLogo(null);
        setTimeRemainingLogo(null);
        // Inital request to get the s3 update url
        try {
            const response = await axios({
                method: 'post',
                url: paths.BACKEND_URL + 'api/upload_logo/',
                data: form_data,
                headers: {
                    'Content-type': 'application/json',
                },
                // signal: this.state.controller.signal,
                withCredentials: true
            });
            if (response.data.access_denied) {
                throw new Error('Access Denied');
            }
            setUploadPercentLogo(0);
            setUploadMessageLogo(type === 'square' ? 'Uploading mobile logo image' : 'Uploading desktop logo image')
            setUploadStepLogo(start_step === 1 && total_steps === 3 ? 'Step 2 of 3:' : start_step === 4 && total_steps === 6 ? 'Step 5 of 6:' : 'Step 2 of 6:');
            const r = await axios.put(response.data.upload_uri, file, {
                headers: {
                    'Content-Type': file.type
                },
                signal: controllerLogo.signal,
                onUploadProgress: progressEvent => {
                    if (!initInterval.current) {
                        // Only runs once
                        initInterval.current = true
                        setUploadStartTimeLogo(Date.now());
                        setFileSizeLogo(progressEvent.total);
                    }
                    let uploadString = ''
                    if (progressEvent.total >= 1048576) {
                        const uploadMB = Math.round(progressEvent.loaded / 1048576)
                        const totalSizeMB = Math.round(progressEvent.total / 1048576)
                        uploadString = `${uploadMB}MB of ${totalSizeMB}MB`
                    }
                    else if (progressEvent.total >= 1024) {
                        const uploadKB = Math.round(progressEvent.loaded / 1024)
                        const totalSizeKB = Math.round(progressEvent.total / 1024)
                        uploadString = `${uploadKB}KB of ${totalSizeKB}KB`
                    }
                    else {
                        const uploadBytes = Math.round(progressEvent.loaded)
                        const totalSizeBytes = Math.round(progressEvent.total)
                        uploadString = `${uploadBytes}Bytes of ${totalSizeBytes}Bytes`
                    }
                    setUploadPercentLogo((progressEvent.loaded / progressEvent.total) * 100)
                    setUploadMessageLogo(`Uploading...(${uploadString})`)
                }
            }
            )
            setUploadPercentLogo(100);
            setUploadMessageLogo(type === 'square' ? 'Processing mobile logo image' : 'Processing desktop logo image');
            setUploadStepLogo(start_step === 1 && total_steps === 3 ? 'Step 3 of 3:' : start_step === 4 && total_steps === 6 ? 'Step 6 of 6:' : 'Step 3 of 6:');
            setTimeRemainingLogo(0);
            // Notify fitwith of completed upload
            const response2 = await notifyUploadCompleteLogo(type)
            if (response2.data.access_denied) {
                throw new Error('Access Denied');
            }
        }
        catch (err) {
            timeRemainingIntervalLogo && clearInterval(timeRemainingIntervalLogo)
            setTimeRemainingIntervalLogo(null);
            setUploadLoadingLogo(false);
            props.setUploadingCustomCreatorLogo(false)
            setFileSizeLogo(0);
            setSnackbarAutoHideLogo(6000);
            const error = err.response?.data?.error
            if (error === 'Invalid file type for image') {
                setErrorMsgLogo(`${error}. Please upload an image with one of the following file types: jpeg, jpg, png`);
                setSnackbarOpen(true);
            }
            else {
                setErrorMsgLogo('Oops. There was an error while uploading. Retry and if the error persists refresh the page and try again.');
                setSnackbarOpen(true);
            }
            throw new Error('Server error')
        }
    }

    async function uploadLogo() {
        let removeSquare = false
        let removeRectangle = false
        if ((props.logoSquareFileNew === '') && (props.logoRectangleFileNew !== '')) {
            setSnackbarOpen(true);
            setErrorMsgLogo('You must have a square logo file to save.');
        } else {
            // get the logos
            let n_steps = 0
            if (props.logoSquareFileNew !== '') {
                n_steps += 3
            }
            if (props.logoRectangleFileNew !== '') {
                n_steps += 3
            }
            if (props.logoSquareFileNew === '') {
                removeSquare = true
                setUploadLoadingLogo(true);
                props.setUploadingCustomCreatorLogo(true)
                setUploadPercentLogo(0);
                setUploadMessageLogo('Removing mobile logo file...');
                setUploadStepLogo('');
                axios({
                    method: 'get',
                    url: paths.BACKEND_URL + 'api/influencer/remove_logo/square',
                    headers: {
                        'Content-type': 'application/json',
                    },
                    // signal: this.state.controller.signal,
                    withCredentials: true
                }).then(res => {
                    setUploadPercentLogo(100);
                })
            } else if (props.logoSquareFileNew !== '' && (props.logoSquareFileNew !== props.logoSquareFile)) {
                setControllerLogo(new AbortController());
                setUploadLoadingLogo(true);
                props.setUploadingCustomCreatorLogo(true)
                setUploadPercentLogo(0);
                setUploadMessageLogo('Preparing mobile logo file...');
                setUploadStepLogo(props.logoRectangleFileNew !== '' ? 'Step 1 of 6:' : 'Step 1 of 3:');
                await uploadLogoFile('square', n_steps, 1);
            }
            if (props.logoRectangleFileNew === '') {
                removeRectangle = true
                setUploadLoadingLogo(true);
                props.setUploadingCustomCreatorLogo(true)
                setUploadPercentLogo(0);
                setUploadMessageLogo('Removing desktop logo file...');
                setUploadStepLogo('');
                axios({
                    method: 'get',
                    url: paths.BACKEND_URL + 'api/influencer/remove_logo/rectangle',
                    headers: {
                        'Content-type': 'application/json',
                    },
                    // signal: this.state.controller.signal,
                    withCredentials: true
                }).then(res => {
                    setUploadPercentLogo(100);
                })
            } else if (props.logoRectangleFileNew !== '' && (props.logoRectangleFileNew !== props.logoRectangleFile)) {
                setControllerLogo(new AbortController());
                setUploadLoadingLogo(true);
                props.setUploadingCustomCreatorLogo(true)
                setUploadPercentLogo(0);
                setUploadMessageLogo('Preparing desktop logo file...');
                setUploadStepLogo(props.logoSquareFileNew !== '' ? 'Step 4 of 6:' : 'Step 1 of 3:');
                await uploadLogoFile('rectangle', n_steps, n_steps - 2);
            }
            setUploadMessageLogo('Finished');
            setUploadStepLogo('');
            props.handleSuccessfulCustomLogo();
            // get the latest files

            axios({
                method: 'get',
                url: paths.BACKEND_URL + 'api/influencer/load_logos',
                headers: {
                    'Content-type': 'application/json',
                },
                // signal: this.state.controller.signal,
                withCredentials: true
            }).then(res => {
                props.setState({
                    logoSquareFile: removeSquare === false ? res.data.square_logo : '',
                    logoRectangleFile: removeRectangle === false ? res.data.rectangle_logo : '',
                    // logoSquareFile: props.logoSquareFileNew === '' ? '' : res.data.square_logo,
                    // logoRectangleFile: props.logoRectangleFileNew === '' ? '' : res.data.rectangle_logo,
                    logoSquareFileNew: '',
                    // currentLogoFile: '',
                    logoRectangleFileNew: '',
                    customCreatorLogoModalOpen: false,
                })
                setUploadLoadingLogo(false);
                props.setUploadingCustomCreatorLogo(false)
            });


        }




    }

    const squareLogoDragOver = (event) => {
        event.preventDefault();
    };

    const rectangleLogoDragOver = (event) => {
        event.preventDefault();
    };

    const squareLogoHandleDrop = (event) => {
        event.preventDefault();
        event.stopPropagation();
        let imageFile = event.dataTransfer.files[0];
        props.setState({ logoSquareFileNew: imageFile });
    };

    const handleSquareLogoSelectClick = () => {
        fileInputRefSquare.current.click();
    };

    const handleRectangleSelectClick = () => {
        fileInputRefRectangle.current.click();
    };

    const rectangleHandleDrop = (event) => {
        event.preventDefault();
        event.stopPropagation();
        let imageFile = event.dataTransfer.files[0];
        props.setState({ logoRectangleFileNew: imageFile });
    };


    // useEffect(() => {
    //
    // }, [props.logoSquareFileNew, props.logoRectangleFileNew, props.logoSquareFile, props.logoRectangleFile] )


    const [rectangleDisplayWidth, setRectangleDisplayWidth] = useState(window.innerWidth);

    useEffect(() => {
        if (window.innerWidth < 380) {
            setRectangleDisplayWidth(260);
        }
        else if (window.innerWidth < 470) {
            setRectangleDisplayWidth(300);
        }
        else if (window.innerWidth < 570) {
            setRectangleDisplayWidth(400);
        } else if (window.innerWidth < 900) {
            setRectangleDisplayWidth(508)
        } else {
            setRectangleDisplayWidth(600)
        }
    }, [window.innerWidth]);

    return (


        <Grid
            Container
            xs={12}
            // justifyContent="center"
            sx={{
                //    backgroundColor: '#FFF',
                marginTop: 'auto',
                marginBottom: { xs: '80px', md: 'auto' },
                marginRight: 'auto',
                marginLeft: 'auto',
                position: 'relative',
                borderRadius: '10px',
            }}
        >
            {/* <p style={{ fontWeight: '500', color: '#6D89AF', fontSize: '16px', margin: '5px 0px 30px 0px' }}>
                Make the platform your own by adding your own branding
            </p> */}


            <div style={{
                border: '1px solid #E4EBF6',
                borderRadius: '8px',
                padding: '0px 20px 10px 20px',
                backgroundColor: '#fff',
                height: 'auto',
                width: 'auto',
            }}>

                <Typography sx={{ fontWeight: '600', color: '#222222', fontSize: { xs: '16px', md: '18px' }, margin: '25px 0px 0px 0px', fontFamily: 'Roboto, sans-serif' }}>
                    Square Logo (Required)
                    <span>
                        <DarkTooltip title="The square logo is your default logo. It shows up on smaller devices and mobiles. If you haven't chosen a desktop logo, it will also be visible on larger devices. For optimal results, we recommend using a .jpg file with a white background." placement="top">
                            <span>
                                <PiInfoBold style={{ fontSize: '20px', margin: '0px 0px -4px 7px', color: '#4B6589' }} />
                            </span>
                        </DarkTooltip></span>
                </Typography>
                <p style={{ fontWeight: '500', color: '#6D89AF', fontSize: '14px', margin: '10px 0px 10px 0px', fontFamily: 'Roboto, sans-serif' }}>Displayed on smaller devices & mobiles. Recommended size: 200px x 200px. Accepted formats: jpg.</p>

                <Grid container md={12} xs={12} style={{ justifyContent: 'left', width: '100%' }}>
                    {props.logoSquareFileNew === '' ?
                        <div
                            className="image-upload"
                            onDragOver={squareLogoDragOver}
                            onDrop={squareLogoHandleDrop}
                            onClick={handleSquareLogoSelectClick}
                            style={{
                                height: '100%',
                                width: '100%',
                                maxHeight: '150px',
                                maxWidth: '150px',
                                aspectRatio: '1/1',
                                margin: '15px 0px',
                            }}
                        >
                            <Grid
                                xs={12}
                                container
                                justifyContent={'center'}
                                alignItems={'center'}
                            >
                                <Typography
                                    sx={{
                                        fontSize: '20px',
                                        fontWeight: '600',
                                        margin: 'auto',
                                    }}
                                >
                                    <img src={IconImage} style={{ width: "20px", height: "20px" }} />
                                    {
                                        window.innerWidth >= 1200 ?
                                            <p style={{ fontSize: '14px', marginTop: '0px', fontWeight: '500', width: '80%', margin: '0px auto', lineHeight: '1.3'}}>Drag your logo here or <span style={{ color: '#3B55F3' }}>click to browse</span></p>
                                            :
                                            <p style={{ fontSize: '14px', marginTop: '0px', color: '#3B55F3', fontWeight: '500', margin: '0px' }}>Select logo</p>
                                    }
                                </Typography>
                            </Grid>

                            <input
                                type="file"
                                accept='.jpeg,.jpg'
                                hidden
                                ref={fileInputRefSquare}
                                onChange={e => {
                                    const file = e.target.files[0];
                                    if (file.type === 'image/jpeg' || file.type === 'image/jpg') {
                                        const img = new Image();
                                        img.src = URL.createObjectURL(file);
                                        img.onload = () => {
                                            // checks if the image is square, can potentially block really bad images if we want
                                            if (img.width !== img.height) {
                                                setErrorMsgLogo('Warning: Your image is not square. For best results, we recommend uploading a square image.');
                                                setSnackbarOpen(true)
                                            } else {
                                                // do nothing
                                            }
                                        };

                                        if (file.size / Math.pow(1000, 3) >= 5) {
                                            setErrorMsgLogo('Your image exceeds the 5GB maximum file size limit. To reduce the size, consider lowering the resolution or converting to a different image format.');
                                            setSnackbarOpen(true)
                                        }
                                        else {
                                            setErrorMsgLogo(''); // Clear any previous error message
                                            props.setState({ logoSquareFileNew: e.target.files[0] })
                                        }
                                    }
                                    else {
                                        setErrorMsgLogo('Unsupported file type. Please select an image with one of the following file types: .jpeg, .jpg.');
                                        setSnackbarOpen(true)
                                    }
                                }}
                            />
                        </div>
                        :
                        <div style={{ position: 'relative', width: '200px', height: '200px', margin: '15px 0px 15px', maxWidth: '200px' }}>
                            <div style={{ display: 'flex', maxWidth: '200px', maxHeight: '200px', minWidth: '200px', minHeight: '200px', border: '1px solid #D3DCE7', borderRadius: '6px', overflow: 'hidden' }}>
                                <img
                                    src={(props.logoSquareFileNew === props.logoSquareFile || props.logoSquareFileNew === '') ? getImageUrl(props.logoSquareFile) : URL.createObjectURL(props.logoSquareFileNew)}
                                    // src={props.logoSquareFileNew === props.logoSquareFile ? props.logoSquareFile : URL.createObjectURL(props.logoSquareFileNew)}
                                    style={{ height: '100%', width: '100%', maxWidth: '200px', maxHeight: '200px', objectFit: 'contain', margin: 'auto' }} />
                            </div>
                            <div style={{ justifyContent: 'flex-end', display: 'flex', width: '200px', position: 'absolute', top: '-15px', right: '-15px' }}>
                                <div style={{ border: '1px #D3DCE7 solid', backgroundColor: '#fff', padding: '5px', height: '18px', width: '18px', margin: '0px 0px 0px 0px', borderRadius: '20px', '&:hover': { cursor: 'pointer' } }}>
                                    <a onClick={() => props.clearSquareLogo()}>
                                        <IoClose className={'content-upload-icons'} />
                                    </a>
                                </div>
                            </div>
                        </div>
                    }
                </Grid>
            </div>

            <div style={{
                border: '1px solid #E4EBF6',
                borderRadius: '8px',
                padding: '0px 20px 10px 20px',
                backgroundColor: '#fff',
                marginTop: '20px',
                height: 'auto',
                width: 'auto',
            }}>
                <Typography sx={{ fontWeight: '600', color: '#222222', fontSize: { xs: '16px', md: '18px' }, margin: '25px 0px 0px 0px', fontFamily: 'Roboto, sans-serif' }}>
                    Rectangle Logo (Optional)<span>
                        <DarkTooltip title="Optional. It appears on larger devices and is crucial for optimising your branding. For optimal results, we recommend using a .jpg file with a white background." placement="top">
                            <span>
                                <PiInfoBold style={{ fontSize: '20px', margin: '0px 0px -4px 7px', color: '#4B6589' }} />
                            </span>
                        </DarkTooltip></span>
                </Typography>
                <p style={{ fontWeight: '500', color: '#6D89AF', fontSize: '14px', margin: '10px 0px 10px 0px',  fontFamily: 'Roboto, sans-serif' }}>Displayed on larger devices & desktops. Recommended size: 900px x 300px. Accepted formats: jpg.</p>

                <Grid container md={12} xs={12} style={{ justifyContent: 'left', width: '100%' }}>
                    {props.logoRectangleFileNew === '' ?
                        <div
                            className="image-upload"
                            onDragOver={rectangleLogoDragOver}
                            onDrop={rectangleHandleDrop}
                            onClick={handleRectangleSelectClick}
                            style={{
                                height: '100%',
                                width: '100%',
                                // maxHeight: rectangleDisplayWidth / 3,
                                // maxWidth: rectangleDisplayWidth,
                                // minHeight: rectangleDisplayWidth / 3,
                                minWidth: '100%',
                                aspectRatio: '3/1',
                                margin: '15px 0px',
                            }}
                        >
                            <Grid
                                xs={12}
                                container
                                justifyContent={'center'}
                                alignItems={'center'}
                            >
                                <Typography
                                    sx={{
                                        fontSize: '20px',
                                        fontWeight: '600',
                                        margin: 'auto',
                                    }}
                                >
                                    <img src={IconImage} style={{ width: "20px", height: "20px" }} />
                                    {
                                        window.innerWidth >= 1200 ?
                                            <p style={{ fontSize: '14px', marginTop: '0px', fontWeight: '500', margin: '0px auto' }}>Drag your logo here or <span style={{ color: '#3B55F3' }}>click to browse</span></p>
                                            :
                                            <p style={{ fontSize: '14px', marginTop: '0px', color: '#3B55F3', fontWeight: '500', margin: '0px' }}>Select logo</p>
                                    }
                                </Typography>
                            </Grid>

                            <input
                                type="file"
                                accept='.jpeg,.jpg'
                                hidden
                                ref={fileInputRefRectangle}
                                onChange={e => {
                                    const file = e.target.files[0];
                                    if (file.type === 'image/jpeg' || file.type === 'image/jpg') {
                                        const img = new Image();
                                        img.src = URL.createObjectURL(file);
                                        img.onload = () => {
                                            if (img.height !== img.width * 3) {
                                                setErrorMsgLogo('Warning: Your image is not the correct sizing. For best results, we recommend uploading a rectangular image with an aspect ratio of 3:1.');
                                                setSnackbarOpen(true)
                                            } else {
                                                // do nothing
                                            }
                                        };

                                        if (file.size / Math.pow(1000, 3) >= 5) {
                                            setErrorMsgLogo('Your image exceeds the 5GB maximum file size limit. To reduce the size, consider lowering the resolution or converting to a different image format.');
                                            setSnackbarOpen(true)
                                        }
                                        else {
                                            setErrorMsgLogo(''); // Clear any previous error message
                                            props.setState({ logoRectangleFileNew: e.target.files[0] })
                                        }
                                    }

                                    else {
                                        setErrorMsgLogo('Unsupported file type. Please select an image with one of the following file types: .jpeg, .jpg.');
                                        setSnackbarOpen(true)
                                    }
                                }}
                            />
                        </div>
                        :
                        <div style={{
                            position: 'relative',
                            // width: '600px', height: '200px',
                            margin: '15px 0px 15px', maxWidth: '600px', width: '100%'
                        }}>
                            <div style={{
                                display: 'flex',
                                // maxHeight: rectangleDisplayWidth / 3,
                                // maxWidth: rectangleDisplayWidth,
                                height: '100%',
                                width: '100%',
                                // minHeight: rectangleDisplayWidth / 3,
                                minWidth: '100%',
                                border: '1px solid #D3DCE7', borderRadius: '6px', overflow: 'hidden'
                            }}>
                                <img
                                    src={(props.logoRectangleFileNew === props.logoRectangleFile || props.logoRectangleFileNew === '') ? getImageUrl(props.logoRectangleFile) : URL.createObjectURL(props.logoRectangleFileNew)}
                                    style={{
                                        // maxHeight: rectangleDisplayWidth / 3,
                                        // maxWidth: rectangleDisplayWidth,
                                        height: '100%',
                                        width: '100%',
                                        imagePosition: 'center',
                                        // minHeight: rectangleDisplayWidth / 3,
                                        minWidth: '100%',
                                        aspectRatio: '3/1',
                                        objectFit: 'contain',
                                        margin: 'auto'
                                    }} />
                            </div>
                            <div style={{ justifyContent: 'flex-end', display: 'flex', width: '600px', position: 'absolute', top: '-15px', right: '-15px' }}>
                                <div style={{ border: '1px #D3DCE7 solid', backgroundColor: '#fff', padding: '5px', height: '18px', width: '18px', margin: '0px 0px 0px 0px', borderRadius: '20px', '&:hover': { cursor: 'pointer' } }}>
                                    <a onClick={() => props.clearRectangleLogo()}>
                                        <IoClose className={'content-upload-icons'} />
                                    </a>
                                </div>
                            </div>
                        </div>
                    }
                </Grid>
            </div>

            <div style={{ marginTop: '15px', paddingBottom: props.windowWidth < 600 ? '50px' : '0px' }}>
                <Button variant="contained" onClick={() => {
                    uploadLogo();
                }} disableElevation
                    sx={{
                        marginTop: '10px',
                        padding: '5px 25px',
                        width: '100%',
                        // maxWidth: '400px',
                        textAlign: 'center',
                        display: 'inline-block',
                        margin: '5px auto',
                        borderRadius: '10px',
                        textTransform: 'none',
                        border: '2px var(--brand-color) solid',
                        backgroundColor: 'var(--brand-color)',
                        '&:hover': {
                            backgroundColor: 'var(--brand-color-hover)',
                            border: '2px var(--brand-color-hover) solid',
                        }
                    }}>
                    <span className="fa fa-search"
                        style={{ fontWeight: '600', fontSize: '16px' }}>Save</span>
                </Button>
            </div>

            <SnackbarAlert
                open={snackbarOpen}
                msg={errorMsgLogo}
                severity="warning"
                autoHideDuration={4000}
                handleClose={() => setSnackbarOpen(false)}
                backgroundColor={'var(--brand-color)'}
            />

            {
                uploadLoadingLogo ?
                    <Modal open={uploadLoadingLogo}>

                        <Box style={modalStyle}
                            sx={{
                                display: 'flex', width: '100%', height: '100%',
                                margin: 'auto'
                            }}>
                            <Grid
                                container
                                spacing={0}
                                direction="column"
                                alignItems="center"
                                justifyContent="center"
                                style={{ minHeight: '90vh' }}
                            >
                                <CircularProgress sx={{
                                    color: 'var(--brand-color)',
                                }} />

                                <p style={{
                                    color: 'var(--primary-text-color)', fontSize: 'var(--medium-text)',
                                    fontWeight: '600',
                                }}>Submitting Post...</p>
                                <p style={{
                                    color: 'var(--primary-text-color)', fontSize: 'var(--medium-text)',
                                    fontWeight: '600',
                                }}>
                                    {Math.round(uploadPercentLogo)}%
                                </p>

                                <div className="upload_toast" style={{ marginTop: '160px', display: 'contents' }}>
                                    <LinearProgress style={{ width: '80vw' }} variant="determinate" defaultValue={0}
                                        value={
                                            uploadPercentLogo
                                            //  50
                                        } />
                                    <p style={{ color: '#fff', fontSize: '12px' }}>
                                        {uploadStepLogo} {uploadMessageLogo}
                                    </p>
                                    {uploadMessageLogo !== 'Finished' && timeRemainingLogo < 60 ?
                                        <p style={{ color: '#fff', fontSize: '12px', position: 'absolute', bottom: '30px' }}>
                                            {timeRemainingLogo !== null ?
                                                `Estimated time remaining: ${timeRemainingLogo} seconds` : 'Calculating time remaining...'
                                            }
                                        </p>
                                        : uploadMessageLogo !== 'Finished' &&
                                        <p style={{ color: '#fff', fontSize: '12px', position: 'absolute', bottom: '30px' }}>
                                            {timeRemainingLogo !== null ?
                                                `Estimated time remaining: ${Math.floor(timeRemainingLogo / 60)} minutes ${timeRemainingLogo % 60} seconds` : 'Calculating time remaining...'
                                            }
                                        </p>
                                    }
                                </div>
                            </Grid>
                        </Box>
                    </Modal>
                    :
                    <div>

                    </div>
            }
        </Grid>
    );
}

export default PlatformBranding;